import script from "./DeckView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeckView.vue?vue&type=script&lang=ts&setup=true"

import "./DeckView.vue?vue&type=style&index=0&id=650806c2&lang=scss"

const __exports__ = script;

export default __exports__